// @copyright  2026 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'settings.link.title.invoice': 'Invoice',
    'settings.link.description.invoice': 'Reminder emails, invoice numbering and the footer printed on your invoices.',

    'settings.page.invoice.title': 'Invoice Settings',
    'settings.page.invoice.description': 'These settings apply to every invoice this organisation issues.',
    'settings.page.invoice.save': 'Save Changes',
    'settings.page.invoice.updated': 'Your invoice settings have been updated.',
    'settings.page.invoice.load_error': 'Sorry, there was an error loading your invoice settings.',

    'settings.page.invoice.reminders.heading': 'Reminder emails',
    'settings.page.invoice.send_reminders.label': 'Send invoice reminder emails',
    'settings.page.invoice.send_reminders.on': 'On',
    'settings.page.invoice.send_reminders.off': 'Off',
    'settings.page.invoice.send_reminders.help':
        'When on, customers are emailed a reminder on the due date and at increasing intervals afterwards while an invoice stays unpaid. When off, no reminders are sent; the schedule still runs quietly, so switching back on resumes at the next reminder date without sending anything missed.',

    'settings.page.invoice.numbering.heading': 'Invoice numbering',
    'settings.page.invoice.next_invoice_number.label': 'Next invoice number',
    'settings.page.invoice.next_invoice_number.help':
        'The number your next posted invoice will receive. Letters followed by digits, up to 12 characters, for example INV0100. Leading zeros set the width. Numbers can only move forward; a number that has already been used cannot be issued again.',
    'settings.page.invoice.next_invoice_number.validation.required': 'The next invoice number is required.',
    'settings.page.invoice.next_invoice_number.validation.format': 'Use letters followed by digits, for example INV0100.',
    'settings.page.invoice.next_invoice_number.validation.max': 'The next invoice number may not be longer than 12 characters.',

    'settings.page.invoice.footer.heading': 'Invoice footer',
    'settings.page.invoice.invoice_footer.label': 'Footer text',
    'settings.page.invoice.invoice_footer.help': 'Printed beneath the totals on every invoice PDF. Use it for payment terms, bank details or a thank-you. Up to 1000 characters; line breaks are kept.',
    'settings.page.invoice.invoice_footer.characters': '{count} of {max} characters',
    'settings.page.invoice.invoice_footer.validation.max': 'The invoice footer may not be longer than 1000 characters.',
};
